<div class="text-center d-flex align-items-center col-12 h-100 px-6">
  <div class="col-12">
    <div class="mb-8">
      <div class="fs-2hx">เวลาในการเรียนหมดแล้ว</div>
      <section
        class="d-flex flex-row justify-content-center align-items-end my-2 postition-relative"
      >
        <app-keenicon name="timer" class="fs-5tx text-danger"></app-keenicon>
        <div
          class="ms-8 ms-sm-12 mb-sm-2 rounded-circle bg-white border border-white position-absolute h-20px h-lg-25px w-fit"
        >
          <app-keenicon
            name="cross-circle"
            type="solid"
            class="fs-1 text-danger"
          ></app-keenicon>
        </div>
      </section>
      <section class="fs-3 fw-light">
        <div class="mb-1">
          คุณได้ใช้เวลาในการเรียนของคอร์สเรียนนี้ไปหมดแล้วจึงไม่สามารถเข้าดูคอร์สเรียนนี้ได้อีก
        </div>
        <div class="d-md-none my-2"></div>
        <div>หากต้องการเรียนคอร์สนี้อีกครั้งกรุณราติดต่อผู้ดูแล</div>
      </section>
    </div>
    <div class="footer">
      <button class="btn btn-secondary bg-gray-200i" (click)="onSubmit()">
        กลับสู่แดชบอร์ด
      </button>
    </div>
  </div>
</div>
